import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const AppointmentReminder = createReducer(
  {
    reminders: [],
    conversation: [],
    loading: false,
    statsLoading: false,
    deleteloading: false,
    deletesuccess: false,
    stats: {
      reminders_sent: 0,
      appointments_confirmed: 0,
      appointments_rescheduled: 0,
      appointments_canceled: 0,
      time_saved: 'PT0S',
    },
  },
  {
    [types.GET_APPOINTMENT_REMINDERS_START](state) {
      const newState = Object.assign({}, state, {
        loading: true,
      });

      return newState;
    },
    [types.GET_APPOINTMENT_REMINDERS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        reminders: action.appointmentreminders,
        loading: false,
      });
      return newState;
    },
    [types.GET_APPOINTMENT_REMINDERS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        loading: false,
      });

      return newState;
    },
    [types.ADD_APPOINTMENT_REMINDERS_START](state) {
      const newState = Object.assign({}, state, {
        loading: true,
      });
      return newState;
    },
    [types.ADD_APPOINTMENT_REMINDERS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        reminders: action.appointmentreminders,
        loading: false,
      });
      return newState;
    },
    [types.ADD_APPOINTMENT_REMINDERS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        loading: false,
      });
      return newState;
    },
    [types.DELETE_APPOINTMENT_REMINDERS_START](state) {
      const newState = Object.assign({}, state, {
        deleteloading: true,
        deletesuccess: false,
      });
      return newState;
    },
    [types.DELETE_APPOINTMENT_REMINDERS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        reminders: action.appointmentreminders,
        deleteloading: false,
        deletesuccess: true,
      });
      return newState;
    },
    [types.DELETE_APPOINTMENT_REMINDERS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        deleteloading: false,
        deletesuccess: false,
      });
      return newState;
    },
    [types.GET_CONVERSATIONS_REMINDERS_START](state) {
      const newState = Object.assign({}, state, {
        loading: true,
      });
      return newState;
    },
    [types.GET_CONVERSATIONS_REMINDERS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        conversation: action.conversation,
        loading: false,
      });
      return newState;
    },
    [types.GET_CONVERSATIONS_REMINDERS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        loading: false,
      });
      return newState;
    },
    [types.GET_REMINDER_STATS_START](state) {
      const newState = Object.assign({}, state, {
        statsLoading: true,
      });
      return newState;
    },
    [types.GET_REMINDER_STATS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        stats: action.stats,
        statsLoading: false,
      });
      return newState;
    },
    [types.GET_REMINDER_STATS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        statsLoading: false,
      });
      return newState;
    },
  },
);

export { AppointmentReminder as default };
